import useProductComparison from '@/hooks/useProductComparison'

import ProductComparisonModal from '../../../../components/ProductComparisonModal'
import ProductGridView from './ProductCardList'
import ProductListView from './ProductCardTable'

const emptyDataSource = []

const ProductContent = ({
  dataSrc = emptyDataSource,
  isListView = false,
  isLoading = false,
}) => {
  const {
    showComparisonModal,
    setShowComparisonModal,
    comparingProductIds,
    onCompareHandler,
    productInformation,
  } = useProductComparison()

  return (
    <>
      {isListView
        ? (
          <ProductListView
            comparingProductIds={comparingProductIds}
            dataSrc={dataSrc}
            isLoading={isLoading}
            onCompareHandler={onCompareHandler}
          />
        )
        : (
          <ProductGridView
            comparingProductIds={comparingProductIds}
            products={dataSrc}
            onCompareHandler={onCompareHandler}
          />
        )}
      <ProductComparisonModal
        productsData={productInformation}
        setShowModal={setShowComparisonModal}
        showModal={showComparisonModal}
      />
    </>
  )
}

export default ProductContent
